<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="here px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">申込者情報の登録</h3>
    <p>以下の必要な項目をご入力のうえ、確認画面へ進むを押してください。</p>
    <div class="form-content">
      <div class="form-member my-5">
        <div class="inner">
          <dl>
            <dt>
              氏名
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="name1"
                ref="name1"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)真奈"
                style="ime-mode: active"
              />
              <input
                v-model="name2"
                ref="name2"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)美須子"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              氏名
              <span class="fs-08">（フリガナ）</span>
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="nameKana1"
                ref="nameKana1"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)マナ"
                style="ime-mode: active"
              />
              <input
                v-model="nameKana2"
                ref="nameKana2"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)ビスコ"
                style="ime-mode: active"
              /><br />
              <p class="fs-09">カタカナで入力してください。</p>
            </dd>
            <dt>
              性別
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="sex"
                ref="sex"
                value="1"
                id="rdoSexW"
                name="sex"
                type="radio"
                class="radio-01"
              />
              <label for="rdoSexW">女性</label>
              <input
                v-model="sex"
                ref="sex"
                value="2"
                id="rdoSexM"
                name="sex"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoSexM">男性</label>
              <input
                v-model="sex"
                ref="sex"
                value="0"
                id="rdoSex"
                name="sex"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoSex">無回答</label>
            </dd>
            <dt>
              配偶者
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="spouse"
                ref="spouse"
                value="1"
                id="rdoSpouseY"
                name="Spouse"
                type="radio"
                class="radio-01"
              />
              <label for="rdoSpouseY">有り</label>
              <input
                v-model="spouse"
                ref="spouse"
                value="2"
                id="rdoSpouseN"
                name="Spouse"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoSpouseN">無し</label>
            </dd>
            <dt>
              生年月日
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <select
                v-model="birthYear"
                class="px-3"
                ref="birthYear"
                id="selBirthYear"
              >
                <option value="">－</option>
                <option v-for="item in yearList" :key="item" :value="item">
                  {{ item }}
                </option></select
              >年
              <select
                v-model="birthMonth"
                ref="birthMonth"
                id="selBirthMonth"
                class="ml-2e px-3"
              >
                <option value="">－</option>
                <option v-for="n of 12" :key="n" :value="n">
                  {{ n }}
                </option></select
              >月
              <select
                v-model="birthDay"
                ref="birthDay"
                id="selBirthDay"
                class="ml-2e px-3"
              >
                <option value="">－</option>
                <option v-for="n of dayCount" :key="n" :value="n">
                  {{ n }}
                </option></select
              >日
            </dd>
            <dt>
              郵便番号
              <span class="rqr">必須</span>
            </dt>
            <dd>
              〒
              <input
                v-model="zipCode"
                ref="zipCode"
                id="txtZipCode"
                maxlength="7"
                type="text"
                inputmode="numeric"
                class="input-name"
                placeholder="(例)2790032"
                style="ime-mode: disabled"
              />
              <button
                v-on:click="zipSearch"
                id="spnZipSearch"
                class="p-serch ml-3 mt-2"
              >
                住所検索
              </button>
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt>
              住所
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="part1OfAddress"
                ref="part1OfAddress"
                id="txtAddress1"
                maxlength="100"
                type="text"
                class="w-100"
                placeholder="(例)千葉県浦安市千鳥15-9"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              住所
              <span class="fs-08">（フリガナ）</span>
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="addressKana"
                ref="addressKana"
                id="txtAddressKana"
                maxlength="300"
                type="text"
                class="w-100"
                placeholder="(例)チバケンウラヤスシチドリ15バンチ8"
                style="ime-mode: active"
              /><br />
              <p class="fs-09">カタカナで入力してください。</p>
            </dd>
            <dt>
              住所
              <span class="fs-08">（建物名）</span>
            </dt>
            <dd>
              <input
                v-model="part2OfAddress"
                ref="part2OfAddress"
                id="txtAddress2"
                maxlength="100"
                type="text"
                class="w-100"
                placeholder="(例)マナビスマンション101"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              住所
              <span class="fs-08">（その他）</span>
            </dt>
            <dd>
              <input
                v-model="part3OfAddress"
                ref="part3OfAddress"
                id="txtAddress3"
                maxlength="100"
                type="text"
                class="w-100"
                placeholder="(例)浦安舞子方"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              配送時連絡先
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="useTelKind"
                ref="useTelKind"
                value="携帯"
                id="rdoUseM"
                name="use"
                type="radio"
                class="radio-01"
              />
              <label for="rdoUseM">携帯電話番号</label>
              <input
                v-model="useTelKind"
                value="固定"
                id="rdoUseK"
                name="use"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoUseK">自宅電話番号</label>
            </dd>
            <dt v-show="useTelKind == '携帯'">
              携帯電話番号
              <span id="spnTelM" class="rqr" style="">必須</span>
            </dt>
            <dd v-show="useTelKind == '携帯'">
              <input
                v-model="telM"
                ref="telM"
                id="txtTelM"
                maxlength="11"
                type="text"
                inputmode="numeric"
                class="input-w30"
                placeholder="(例)99999999999"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt v-show="useTelKind == '固定'">
              自宅電話番号
              <span id="spnTelK" class="rqr">必須</span>
            </dt>
            <dd v-show="useTelKind == '固定'">
              <input
                v-model="telK"
                ref="telK"
                id="txtTelK"
                maxlength="10"
                type="text"
                inputmode="numeric"
                class="input-w30"
                placeholder="(例)9999999999"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt>FAX番号</dt>
            <dd>
              <input
                v-model="telF"
                ref="telF"
                id="txtTelF"
                maxlength="10"
                type="text"
                inputmode="numeric"
                class="input-w30"
                placeholder="(例)0888888888"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt>
              紹介者の氏名
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="spoName1"
                ref="spoName1"
                id="txtSpoName1"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)浦安"
                style="ime-mode: active"
              />
              <input
                v-model="spoName2"
                ref="spoName2"
                id="txtSpoName2"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)舞子"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              紹介者の氏名
              <span class="fs-08">（フリガナ）</span>
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="spoNameKana1"
                ref="spoNameKana1"
                id="txtSpoNameKana1"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)ウラヤス"
                style="ime-mode: active"
              />
              <input
                v-model="spoNameKana2"
                ref="spoNameKana2"
                id="txtSpoNameKana2"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)マイコ"
                style="ime-mode: active"
              /><br />
              <p class="fs-09">カタカナで入力してください。</p>
            </dd>
            <dt>
              紹介者の会員番号
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="spoNumber"
                ref="spoNumber"
                id="txtSpoNumber"
                maxlength="10"
                type="text"
                inputmode="numeric"
                class="input-w30"
                style="ime-mode: disabled"
              />
            </dd>
            <dt>
              紹介者の電話番号
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="spoTelNumber"
                ref="spoTelNumber"
                id="txtSpoTel"
                maxlength="11"
                type="text"
                inputmode="numeric"
                class="input-w30"
                placeholder="(例)9999999999"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt>
              パスワード
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="passWord"
                ref="passWord"
                id="txtPasswd"
                type="password"
                maxlength="12"
                class="input-w30"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">
                半角英数字の組合せ8～12文字以内で、ご自由にお決めください。<br />
                ここで入力したパスワードは、会員サイトへのログイン用になります。
              </p>
            </dd>
            <dt>
              当社からの広告等のメール・SMS・FAX送信
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="wantMail"
                ref="wantMail"
                value="1"
                id="rdoWantMailY"
                name="mss"
                type="radio"
                class="radio-01"
              />
              <label for="rdoWantMailY">承諾する</label>
              <input
                v-model="wantMail"
                ref="wantMail"
                value="0"
                id="rdoWantMailN"
                name="mss"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoWantMailN">承諾しない</label>
            </dd>
          </dl>
          <div
            class="
              important-matter
              border-bottom border-left border-right
              px-4
              py-4
            "
          >
            <p class="exp py-3">
              重要事項に同意いただける方は「同意する」にチェックを入れて確認画面へお進みください。
            </p>
            <p class="title text-center"><strong>重要事項</strong></p>
            <p class="exp my-3">
              私は、紹介者より説明を受け、クーリング・オフを含む重要事項の内容を理解し、納得の上、マナビス・ショッピングクラブ会員に登録いたします。<br>
              なお、マナビス化粧品の「個人情報保護方針」に基づき、同系列の上位会員に個人情報を提供することを承諾します。
            </p>
            <p align="center" class="fs-14">
              <input
                v-model="consent"
                ref="consent"
                value="true"
                id="chkConsent"
                type="checkbox"
                class="check-02"
              />
              <label for="chkConsent"><strong>同意する</strong></label>
            </p>
          </div>
          <div class="box-p-20 text-center">
            <button
              v-on:click="putData"
              id="btnConfirm"
              type="button"
              class="confirm-01 clear"
            >
              確認画面へ進む
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>

<script>
import Request from "@/modules/Request";
let request = new Request();
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
import moment from "moment";
import Message from "@/modules/Message";
import Utl from "@/modules/Utl";
export default {
  data() {
    return {
      name1: "",
      name2: "",
      nameKana1: "",
      nameKana2: "",
      sex: "",
      spouse: "",
      birthYear: "",
      birthMonth: "",
      birthDay: "",
      zipCode: "",
      part1OfAddress: "",
      addressKana: "",
      part2OfAddress: "",
      part3OfAddress: "",
      useTelKind: "",
      telM: "",
      telK: "",
      telF: "",
      spoName1: "",
      spoName2: "",
      spoNameKana1: "",
      spoNameKana2: "",
      spoNumber: "",
      spoTelNumber: "",
      passWord: "",
      wantMail: "",
      consent: "",
      yearList: [],
      dayCount: [],
    };
  },

  mounted() {
    this.getSettion();
    this.setBirthYear();
    window.scroll(0, 0);
  },

  watch: {
    birthYear: function (sel) {
      if (sel != "" && this.birthMonth != "") this.setBirthDay();
    },
    birthMonth: function (sel) {
      if (sel != "" && this.birthYear != "") this.setBirthDay();
    },
  },

  methods: {
    getSettion() {
      //セッションのエラー時の処理を追加したい。
      if (this.$route.params.uux) {
        auth.setNoLoginUid(this.$route.params.uux);
      }
      this.getData();
    },
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getRegistration",
        [true],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.toError) {
            auth.removeNoLoginUid();
            this.$router.push({
              path: "/registration/error",
            });
          }
          this.name1 = data.name1;
          this.name2 = data.name2;
          this.nameKana1 = data.nameKana1;
          this.nameKana2 = data.nameKana2;
          this.sex = data.sex;
          this.spouse = data.spouse;
          this.setBirthYear();
          if (data.birthYear != "" && data.birthMonth != "") {
            this.birthYear = data.birthYear;
            this.birthMonth = data.birthMonth;
            this.birthDay = data.birthDay;
          }
          this.zipCode = data.zipCode;
          this.part1OfAddress = data.part1OfAddress;
          this.addressKana = data.addressKana;
          this.part2OfAddress = data.part2OfAddress;
          this.part3OfAddress = data.part3OfAddress;
          this.useTelKind = data.useTelKind;
          this.telM = data.TelM;
          this.telK = data.TelK;
          this.telF = data.TelF;
          this.spoName1 = data.spoName1;
          this.spoName2 = data.spoName2;
          this.spoNameKana1 = data.spoNameKana1;
          this.spoNameKana2 = data.spoNameKana2;
          this.spoNumber = data.spoNumber;
          this.spoTelNumber = data.SpoTelNumber;
          this.passWord = data.passWord;
          this.wantMail = data.wantMail;
        });
    },

    putData() {
      if (!this.chkInput()) return;
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putRegistrationShopping",
        [
          this.name1,
          this.name2,
          this.nameKana1,
          this.nameKana2,
          this.sex,
          this.spouse,
          this.birthYear + "/" + this.birthMonth + "/" + this.birthDay,
          this.zipCode,
          this.part1OfAddress,
          this.part2OfAddress,
          this.part3OfAddress,
          this.addressKana,
          this.useTelKind,
          this.telM,
          this.telK,
          this.telF,
          this.spoName1,
          this.spoName2,
          this.spoNameKana1,
          this.spoNameKana2,
          this.spoNumber,
          this.spoTelNumber,
          this.passWord,
          this.wantMail,
        ],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
              didClose: () => {
                return;
              },
            });
          } else {
            this.$router.push({
              path: "/shopping/registration/confirm",
            });
          }
        });
    },
    getSession() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getSession",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          console.log(data)
          if (auth.getNoLoginUid() == "") {
            console.log('setNoLoginUid')
            auth.setNoLoginUid(data.uux);
          }
          this.getData();
        });
    },
    zipSearch() {
      if (!this.chkZipCode()) return;
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getAddressFromZip",
        [this.zipCode],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
              didClose: () => {
                this.$refs.zipCode.focus();
                return;
              },
            });
          }
          this.part1OfAddress = data.address;
          this.addressKana = data.addressKana;
        });
    },
    chkInput() {
      if (!this.chkName()) return false;
      if (!this.chkKana()) return false;
      if (!this.chkSex()) return false;
      if (!this.chkSpouse()) return false;
      if (!this.chkBirthDay()) return false;
      if (!this.chkZipCode()) return false;
      if (!this.chkAddress()) return false;
      if (!this.chkUseTelKind()) return false;
      if (this.useTelKind == "携帯") {
        if (!this.chkTelM()) return false;
      } else if (this.useTelKind == "固定") {
        if (!this.chkTelK()) return false;
      }
      if (!this.chkTelF()) return false;
      if (!this.chkSpoName()) return false;
      if (!this.chkSpoKana()) return false;
      if (!this.chkSpoNumber()) return false;
      if (!this.chkSpoTelNumber()) return false;
      if (!this.chkPassWord()) return false;
      if (!this.chkwantMail()) return false;
      if (!this.chkConsent()) return false;
      return true;
    },

    setBirthYear() {
      const today = new moment();
      //100歳から16歳まで表示する
      for (let i = -100; i < -15; i++) {
        let date = moment(today.format("yyyy"));
        this.yearList.push(date.add(i, "year").format("yyyy"));
      }
    },

    setBirthDay() {
      this.dayCount = moment(
        this.birthYear + "-" + ("0" + this.birthMonth).slice(-2) + "-01"
      ).daysInMonth();
    },

    chkName() {
      let mes = Utl.chkMustInput("氏名の姓", this.name1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.name1.focus();
          },
        });
        return false;
      }
      mes = Utl.chkCanUseChars("氏名の姓", this.name1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.name1.focus();
          },
        });
        return false;
      } else {
        let mes = Utl.chkMustInput("氏名の名", this.name2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.name2.focus();
            },
          });
          return false;
        }
        mes = Utl.chkCanUseChars("氏名の名", this.name2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.name2.focus();
            },
          });
          return false;
        }
      }
      return true;
    },

    chkKana() {
      let mes = Utl.chkMustInput("氏名(フリガナ)の姓", this.nameKana1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.nameKana1.focus();
          },
        });
        return false;
      }
      mes = Utl.chkCanUseKana("氏名(フリガナ)の姓", this.nameKana1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.nameKana1.focus();
          },
        });
        return false;
      } else {
        mes = Utl.chkMustInput("氏名(フリガナ)の名", this.nameKana2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.nameKana2.focus();
            },
          });
          return false;
        }
        mes = Utl.chkCanUseKana("氏名(フリガナ)の名", this.nameKana2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.nameKana2.focus();
            },
          });
          return false;
        }
      }
      return true;
    },

    chkSex() {
      if (!this.sex) {
        Message.error().fire({
          title: "性別を選択してください。",
          didClose: () => {
            this.$refs.sex.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkSpouse() {
      if (!this.spouse) {
        Message.error().fire({
          title: "配偶者の有無を選択してください。",
          didClose: () => {
            this.$refs.spouse.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkBirthDay() {
      if (!this.birthYear) {
        Message.error().fire({
          title: "生年月日の年を選択してください。",
          didClose: () => {
            this.$refs.birthYear.focus();
          },
        });
        return false;
      }
      if (!this.birthMonth) {
        Message.error().fire({
          title: "生年月日の月を選択してください。",
          didClose: () => {
            this.$refs.birthMonth.focus();
          },
        });
        return false;
      }
      if (!this.birthDay) {
        Message.error().fire({
          title: "生年月日の日を選択してください。",
          didClose: () => {
            this.$refs.birthDay.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkZipCode() {
      let mes = Utl.chkMustInput("郵便番号", this.zipCode);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.zipCode.focus();
          },
        });
        return false;
      }
      mes = Utl.chkZipCode("郵便番号", this.zipCode);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.zipCode.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkAddress() {
      let mes = Utl.chkMustInput("住所", this.part1OfAddress);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.part1OfAddress.focus();
          },
        });
        return false;
      }
      mes = Utl.chkMustInput("住所(フリガナ)", this.addressKana);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.addressKana.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkUseTelKind() {
      if (this.useTelKind.length == 0) {
        Message.error().fire({
          title: "配送時連絡先を選択してください。",
          didClose: () => {
            this.$refs.useTelKind.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkTelM() {
      if (this.telM.length == 0) {
        Message.error().fire({
          title: "携帯電話番号を入力してください。",
          didClose: () => {
            this.$refs.telM.focus();
          },
        });
        return false;
      }
      let mes = Utl.chkNum("携帯電話番号", this.telM);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.telM.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkTelK() {
      if (this.telK.length == 0) {
        Message.error().fire({
          title: "固定電話番号を入力してください。",
          didClose: () => {
            this.$refs.telK.focus();
          },
        });
        return false;
      }
      let mes = Utl.chkNum("固定電話番号", this.telK);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.telK.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkTelF() {
      let mes = "";
      if (this.telF.length > 0) {
        mes = Utl.chkNum("FAX番号", this.telK);
      }
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.telK.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkSpoName() {
      let mes = Utl.chkMustInput("紹介者の氏名の姓", this.spoName1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.spoName1.focus();
          },
        });
        return false;
      }
      mes = Utl.chkCanUseChars("紹介者の氏名の姓", this.spoName1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.spoName1.focus();
          },
        });
        return false;
      } else {
        let mes = Utl.chkMustInput("紹介者の氏名の名", this.spoName2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.spoName2.focus();
            },
          });
          return false;
        }
        mes = Utl.chkCanUseChars("紹介者の氏名の名", this.spoName2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.spoName2.focus();
            },
          });
          return false;
        }
      }
      return true;
    },

    chkSpoKana() {
      let mes = Utl.chkMustInput(
        "紹介者の氏名(フリガナ)の姓",
        this.spoNameKana1
      );
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.spoNameKana1.focus();
          },
        });
        return false;
      }
      mes = Utl.chkCanUseKana(
        "紹介者の氏名(フリガナ)の姓",
        this.spoNameKana1
      );
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.spoNameKana1.focus();
          },
        });
        return false;
      } else {
        mes = Utl.chkMustInput(
          "紹介者の氏名(フリガナ)の名",
          this.spoNameKana2
        );
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.spoNameKana2.focus();
            },
          });
          return false;
        }
        mes = Utl.chkCanUseKana(
          "紹介者の氏名(フリガナ)の名",
          this.spoNameKana2
        );
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.spoNameKana2.focus();
            },
          });
          return false;
        }
      }
      return true;
    },

    chkSpoNumber() {
      if (this.spoNumber.length == 0) {
        Message.error().fire({
          title: "紹介者の会員番号を入力してください。",
          didClose: () => {
            this.$refs.spoNumber.focus();
          },
        });
        return false;
      }
      let mes = Utl.chkNum("紹介者の会員番号", this.spoNumber);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.spoNumber.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkSpoTelNumber() {
      if (this.spoTelNumber.length == 0) {
        Message.error().fire({
          title: "紹介者の電話番号を入力してください。",
          didClose: () => {
            this.$refs.spoTelNumber.focus();
          },
        });
        return false;
      }
      let mes = Utl.chkNum("紹介者の電話番号", this.spoTelNumber);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.spoTelNumber.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkPassWord() {
      let mes = Utl.chkMustInput("パスワード", this.passWord);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.passWord.focus();
          },
        });
        return false;
      }
      mes = Utl.chkPassword("パスワード", this.passWord);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.passWord.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkwantMail() {
      if (this.wantMail.length == 0) {
        Message.error().fire({
          title: "当社からの広告等のメール・FAX送信を選択してください",
          didClose: () => {
            this.$refs.wantMail.focus();
          },
        });
        return false;
      }
      return true;
    },

    chkConsent() {
      if (this.consent != true) {
        Message.error().fire({
          title:
            "重要事項に同意頂ける方は「同意する」にチェックを入れてください。",
          didClose: () => {
            this.$refs.consent.focus();
          },
        });
        return false;
      }
      return true;
    },
  },
};
</script>